import { FC, PropsWithChildren } from "react";
import styled, { useTheme } from "styled-components";

const BlurComponent = styled.div`
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  background-color: rgba(255, 255, 255, 0.4); /* translucent white */
  border-radius: 50%;
  padding: 4px;
  display: inline-flex;
`;

export const ButtonBlurrer: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();

  return theme?.themeConfig?.chatButton?.buttonBlur ? (
    <BlurComponent className="voa_button_border_blurrer">
      {children}
    </BlurComponent>
  ) : (
    <>{children}</>
  );
};
